import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as accountActions from '@brainstud/react-tbl/themes/pgw/v1/store/actions/accountActions'
import { withApp, compareAnswers, getRandomItemFromArray, shuffleArray } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { Loading } from '@brainstud/react-tbl/themes/pgw/v1/components/library'

const defaultQuizConfig = {
  introductionPage: true,
  casualMode: false,
  maxAttempts: 3,
  scoreToPass: 80,
  totalCaseCount: 3,
  timeToComplete: 60,
  isCompleteAnimationOver: false,
}

const defaultQuizAttempt = {
  cases: [],
  passed: false,
  completed: false,
  progressCount: 0,
  progressPercent: 0,
  scoreCount: 0,
  scorePercent: 0,
}

const { Provider: ContextProvider, Consumer } = React.createContext()

class QuizProvider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      config: null,
      quiz: null,
    }
  }

  componentDidMount() {
    this.props.accountActions.getUser(this.init)
  }

  init = () => {
    const config = {...defaultQuizConfig, ...this.props.config}
    const remainingAttempts = this.props.account.quiz && this.props.account.quiz.remainingAttempts > -1 ? this.props.account.quiz.remainingAttempts : config.maxAttempts - 1
    const attempt = this.props.account.quiz && this.props.account.quiz.attempt ? this.props.account.quiz.attempt : defaultQuizAttempt
    const cases = this.props.account.quiz && this.props.account.quiz.attempt ? this.props.account.quiz.attempt.cases : this.getRandomCases(config.totalCaseCount)
    const history = this.props.account.quiz && this.props.account.quiz.history ? this.props.account.quiz.history : []
    const isCompleteAnimationOver = this.props.account.quiz && this.props.account.quiz.attempt && this.props.account.quiz.attempt.completed ? true : false
    const complyAgreement = this.props.account.quiz && this.props.account.quiz.complyAgreement ? this.props.account.quiz.complyAgreement : false

    this.setState(prevState => ({
      config: {
        ...config,
        checkAnswer: this.checkAnswer,
        startAgain: this.startAgain,
        getCases: this.getCases,
        updateComplyAgreement: this.updateComplyAgreement,
        isCompleteAnimationOver: isCompleteAnimationOver,
      },
      quiz: {
        complyAgreement: complyAgreement,
        remainingAttempts: remainingAttempts,
        attempt: {
          ...attempt,
          cases: cases,
        },
        history: history,
      },
    }), this.updateUser)
  }

  checkAnswer = (answers, caseId) => {
    this.setState(prevState => {
      const correctAnswers = []
      const userAnswers = []

      // Collect user and correct
      this.getCases().map(itemCase => {
        if(itemCase.id === caseId) {
          return itemCase.question.answers.map(itemAnswer => {
            if(itemAnswer.isCorrect)
              correctAnswers.push({ id: itemAnswer.id })

            answers.map(answerId => {
              if(+answerId === itemAnswer.id) {
                userAnswers.push({ id: itemAnswer.id })
              }
              return null
            })
            return null
          })
        }
        return null
      })

      const caseStatus = {
        isComplete: true,
        isCorrect: compareAnswers(correctAnswers, userAnswers),
        isWrong: !compareAnswers(correctAnswers, userAnswers),
        correctAnswers,
        userAnswers
      }

      const addToProgressCount = prevState.quiz.attempt.progressCount + 1
      const addToProgressPercent = Math.round(addToProgressCount / prevState.config.totalCaseCount * 100)
      const addToScoreCount = caseStatus.isCorrect ? prevState.quiz.attempt.scoreCount + 1 : prevState.quiz.attempt.scoreCount
      const addToScorePercent = Math.round(addToScoreCount / prevState.config.totalCaseCount * 100)
      const hasPassed = addToScorePercent >= prevState.config.scoreToPass
      const hasCompleted = addToProgressPercent >= 100 || addToProgressCount === prevState.config.totalCaseCount

      return {
        quiz: {
          ...prevState.quiz,
          attempt: {
            ...prevState.quiz.attempt,
            passed: hasPassed,
            completed: hasCompleted,
            progressCount: addToProgressCount,
            progressPercent: addToProgressPercent,
            scoreCount: addToScoreCount,
            scorePercent: addToScorePercent,
            cases: prevState.quiz.attempt.cases.map(item => item.id === caseId
              ? {...item, status: caseStatus }
              : {...item}),
          }
        }
      }
    }, () => {
      if(this.state.quiz.attempt.completed) {
        setTimeout(() => {
          this.setState(prevState => ({
            config: {
              ...prevState.config,
              isCompleteAnimationOver: true,
            },
          }))

          this.props.app.triggerEvent('completed')
        }, 2000)
      }

      this.updateUser()
    })
  }

  startAgain = () => {
    this.setState(prevState => ({
      config: {
        ...prevState.config,
        isCompleteAnimationOver: false,
      },
      quiz: {
        ...prevState.quiz,
        remainingAttempts: prevState.quiz.remainingAttempts - 1,
        attempt: {
          ...defaultQuizAttempt,
          cases: this.getRandomCases(prevState.config.totalCaseCount, prevState.quiz.history.concat(prevState.quiz.attempt)),
        },
        history: prevState.quiz.history.concat(prevState.quiz.attempt),
      },
    }), this.updateUser)
  }

  getRandomCases = (total, history = []) => {
    const categriesCount = this.props.cases.length
    const perCategory = Math.floor(total / categriesCount)
    //const itemsRest = total % categriesCount

    const usedCases = history.reduce((acc, item) => {
      return acc.concat(item.cases.map(caseItem => caseItem.id))
    }, [])

    const uniqueCases = this.props.cases.map(categoryArray => {
      return categoryArray.reduce((acc, item) => {
        return usedCases.indexOf(item.id) === -1
          ? acc.concat(item)
          : acc
      }, [])
    })

    const allCases = uniqueCases.reduce((acc, item) => {
      return acc.concat(item)
    }, [])

    const casesPerCategory = uniqueCases.reduce((acc, category) => {
      const itemsFromCategory = getRandomItemFromArray(category, perCategory)
      return acc.length < total
        ? acc.concat(itemsFromCategory)
        : acc
    }, [])

    const remainingCases = allCases.reduce((acc, item) => {
      const exists = casesPerCategory.find(caseItem => caseItem.id === item.id)
      return !exists ? acc.concat(item) : acc
    }, [])

    const finalCases = casesPerCategory.length < total
      ? casesPerCategory.concat(getRandomItemFromArray(remainingCases, total - casesPerCategory.length))
      : casesPerCategory

    const cases = total > 1 ? shuffleArray(finalCases) : getRandomItemFromArray(allCases, 1)

    return cases.reduce((acc, item) => {
      return acc.concat({ id: item.id })
    }, [])
  }

  getCases = () => {
    const allCases = this.props.cases.reduce((acc, item) => {
      return acc.concat(item)
    }, [])

    return this.state.quiz.attempt.cases.map(item => {
      const currentCase = allCases.find(caseItem => caseItem.id === item.id)
      return {...item, ...currentCase}
    })
  }

  updateUser = () => {
    this.props.accountActions.updateUser({
      user: this.props.account.user,
      quiz: this.state.quiz,
    })
  }

  updateComplyAgreement = status => {
    this.setState(prevState => ({
      quiz: {
        ...prevState.quiz,
        complyAgreement: status
      }
    }), this.updateUser)
  }

  render() {
    return (
      <ContextProvider value={this.state}>
        {this.state.config && this.props.account.isLoggedIn && this.props.children}
        {!this.props.account.isLoggedIn && <Loading />}
      </ContextProvider>
    )
  }
}

const QuizProviderWithApp = withApp(connect(
  (state, props) => ({
    cases: state.cases.cases,
    account: state.account,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(QuizProvider))

const withQuiz = Component => props => (
  <Consumer>
    {state => <Component quiz={state} {...props} />}
  </Consumer>
)

export {
  QuizProviderWithApp as QuizProvider,
  Consumer as QuizConsumer,
  withQuiz
}